import { callApi } from './common'

function list(accountId) {
  return callApi(`billing/promotion_credit/${accountId}`)
}

function get(accountId, creditId) {
  return callApi(`billing/promotion_credit/${accountId}/${creditId}`)
}

function latestHistory(accountId, date, params) {
  return callApi(
    `billing/promotion_credit_history/${accountId}/date/${date}/latest`,
    params
  )
}

export default {
  list,
  get,
  latestHistory,
}
